import React, {useContext} from 'react';
import AdviserContextProvider from './AdviserContextProvider';
import AdviserContext from './AdviserContext';
import LoadingPage from "../../views/LoadingPage";

/**
 * Inserts UserContextProvider in the react tree
 * before adding the given component.
 *
 * @param {Object} Component The component that needs the context provider.
 * @returns {Object} The component to render wrapped with the provider.
 */
const withAdviserContextProvider = (Component) => (props) => (
    <AdviserContextProvider>
        <Component {...props} />
    </AdviserContextProvider>
);

/**
 * Renders the given component when the user context is ready.
 *
 * @param {Object} Component The component to render.
 * @param {Object} Component The rendered component.
 * @returns {Object} The component to render or the LoadingPage component.
 */
const withAdviserContextReady = (Component) => (props) => {

    const {isReady} = useContext(AdviserContext);
    return isReady ? <Component {...props} /> :
        <LoadingPage/>
};

export {
    withAdviserContextReady,
    withAdviserContextProvider,
};